import gql from 'graphql-tag';

export class PostMutations {
  static setSeenBy = gql`
    mutation setPostSeenBy($postId: String!) {
      setPostSeenBy(postId: $postId)
    }
  `;
}
